import I18n from 'APP/I18n'
import { validateIsValidDate, validateIsNotFuture } from 'APP/Lib/DateHelpers'
import Regex from 'APP/Lib/Regex'

export const getValidationMessages = () => ({
  dateOfBirth: {
    required: I18n.t('ProfileScreen.error.invalidBdayRequiredField') ?? '',
    invalidDate: I18n.t('FamilyScreen.AddDependentScreen.add.error.invalidDate') ?? '',
    futureDate: I18n.t('FamilyScreen.AddDependentScreen.add.error.invalidFutureDate') ?? '',
  },
  firstName: {
    required: I18n.t('Form.error.required') ?? '',
  },
  lastName: {
    required: I18n.t('Form.error.required') ?? '',
  },
  email: {
    required: I18n.t('Form.error.required') ?? '',
    invalid: I18n.t('Form.error.invalidEmail') ?? '',
  },
})

export const dateOfBirthValidationRules = () => {
  const messages = getValidationMessages()
  return {
    required: messages.dateOfBirth.required,
    validate: {
      isValid: (value: unknown) => validateIsValidDate(value) || messages.dateOfBirth.invalidDate,
      isNotFuture: (value: unknown) =>
        validateIsNotFuture(value) || messages.dateOfBirth.futureDate,
    },
  }
}

export const firstNameValidationRules = (isChild: boolean) => {
  const messages = getValidationMessages()
  return {
    required: isChild ? messages.firstName.required : false,
  }
}

export const lastNameValidationRules = (isChild: boolean) => {
  const messages = getValidationMessages()
  return {
    required: isChild ? messages.lastName.required : false,
  }
}

export const emailValidationRules = (isAdult: boolean) => {
  const messages = getValidationMessages()
  return {
    required: isAdult ? messages.email.required : false,
    ...(isAdult && {
      pattern: {
        value: Regex.email,
        message: messages.email.invalid,
      },
    }),
  }
}
